import { Component, inject, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EtjansterSites } from '@vinnova/e-tjanster';
import { ModalService } from '@vinnova/ui';
import { environment } from '../../../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-public',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  standalone: false,
})
export class PublicLayoutComponent implements OnInit {
  isProduction = false;
  EtjansterSites = EtjansterSites;
  headerAndFooterVisible = true;

  private readonly modalService = inject(ModalService);

  ngOnInit() {
    this.isProduction = environment.production;
  }
}
